import { inject } from '@angular/core';

import { TimeService } from '@core/common-legacy';
import { injectTranslate } from '@core/i18n-legacy';
import { textCellFactory } from '@core/user-interface-legacy';

import { AsksColumnId, defineAskTableColumn } from './types';

export const submittedAtColumn = defineAskTableColumn(() => {
  const timeService = inject(TimeService);
  const translate = injectTranslate();
  return {
    id: AsksColumnId.SubmittedAt,
    label: translate('tlc.ask_hr.requests.date_submitted'),
    visible: true,
    geometry: {
      width: 200,
      minWidth: 150,
      autoFitProp: 'width',
    },
    options: {
      draggable: true,
      resizable: true,
      removable: false,
      sortable: true,
    },
    componentFactory: textCellFactory('createdAt', date =>
      timeService.format({ input: date, pattern: 'DD MMM YYYY' }),
    ),
  };
});

export const submittedAtUserColumn = defineAskTableColumn(() => {
  const timeService = inject(TimeService);
  const translate = injectTranslate();
  return {
    id: AsksColumnId.SubmittedAt,
    label: translate('tlc.ask_hr.requests.date_submitted'),
    visible: true,
    geometry: {
      width: 219,
      minWidth: 150,
      autoFitProp: 'width',
    },
    options: {
      draggable: false,
      resizable: false,
      removable: false,
      sortable: true,
    },
    componentFactory: textCellFactory('createdAt', date =>
      timeService.format({ input: date, pattern: 'DD MMM YYYY' }),
    ),
  };
});
